import { ItemComponent } from '@seiue/ui'

import { BlockStateEnum } from 'packages/feature-utils/test-paper'
import { PaperBlock } from 'packages/sdks-next/growp'

import { BlockWrapper } from '../../BlockWrapper'

import { HeaderBlock } from './Block'
import { HeaderSelectedFooter } from './HeaderSelectedFooter'

/**
 * 标题块
 *
 * @param param - Argument Object
 * @param param.blockData - 块数据
 * @param param.dragSource - 拖拽源
 * @constructor
 */
export const BlockHeader: ItemComponent<{
  blockData: PaperBlock
}> = ({ blockData, dragSource }) => (
  <BlockWrapper
    dragSource={dragSource}
    blockData={blockData}
    block={HeaderBlock}
    footers={[
      {
        visible: (f) => f.state === BlockStateEnum.Selected,
        render: HeaderSelectedFooter,
      },
    ]}
  />
)
